export function getGeoBreadCrumbs(geoElements, {beaches, others} = {}) {
    let breadcrumbs = [{
        label: 'Italia',
        url: '/le-migliori-spiagge-italiane'
    }];
    if(!geoElements || !Array.isArray(geoElements)) {
        return breadcrumbs;
    }
    const region = geoElements.find(({type}) => type === "region");
    if(region) {
        breadcrumbs = [
            ...breadcrumbs,
            {
                label: region.name,
                url: `/le-migliori-spiagge-in-${region.slug}`
            }
        ]
    }
    const district = geoElements.find(({type}) => type === "district");
    if(district) {
        breadcrumbs = [
            ...breadcrumbs,
            {
                label: district.name,
                url: `/le-migliori-spiagge-in-provincia-di-${district.slug}`
            }
        ]
    }
    const city = geoElements.find(({type}) => type === "city");
    if(city) {
        breadcrumbs = [
            ...breadcrumbs,
            {
                label: city.name,
                url: `/luoghi/${city.slug}`
            }
        ]
    }
    const poi = geoElements.find(({type}) => type === "pointofinterest");
    if(poi) {
        breadcrumbs = [
            ...breadcrumbs,
            {
                label: poi.name,
                url: `/luoghi/${poi.slug}`
            }
        ]
    };

    if(!!beaches) {
        let lastelement = poi || city;
        if(lastelement) {
            breadcrumbs = [
                ...breadcrumbs,
                {
                    label: "Spiagge",
                    url: `/luoghi/${lastelement.slug}/spiagge`
                }
            ]
        }
    }

    if(others) {
        breadcrumbs = [
            ...breadcrumbs,
            ...others
        ]
    }
    return breadcrumbs;
}

export function getGeoBreadCrumbsHotel(geoElements, {hotels} = {}) {
    let breadcrumbs = [{
        label: 'Italia',
        url: '/i-migliori-hotel-italiani'
    }];
    if(!geoElements || !Array.isArray(geoElements)) {
        return breadcrumbs;
    }
    const region = geoElements.find(({type}) => type === "region");
    if(region) {
        breadcrumbs = [
            ...breadcrumbs,
            {
                label: region.name,
                url: `/i-migliori-hotel-in-${region.slug}`
            }
        ]
    }
    const district = geoElements.find(({type}) => type === "district");
    if(district) {
        breadcrumbs = [
            ...breadcrumbs,
            {
                label: district.name,
                url: `/i-migliori-hotel-in-provincia-di-${district.slug}`
            }
        ]
    }
    const city = geoElements.find(({type}) => type === "city");
    if(city) {
        breadcrumbs = [
            ...breadcrumbs,
            {
                label: city.name,
                url: `/luoghi/${city.slug}`
            }
        ]
    }
    const poi = geoElements.find(({type}) => type === "pointofinterest");
    if(poi) {
        breadcrumbs = [
            ...breadcrumbs,
            {
                label: poi.name,
                url: `/luoghi/${poi.slug}`
            }
        ]
    };

    if(!!hotels) {
        let lastelement = poi || city;
        if(lastelement) {
            breadcrumbs = [
                ...breadcrumbs,
                {
                    label: "Hotel",
                    url: `/luoghi/${lastelement.slug}/hotel`
                }
            ]
        }
    }
    return breadcrumbs;
}